import { useEffect, useState, useRef } from 'react'
import Modal from 'react-bootstrap/Modal'
import Form from 'react-bootstrap/Form'
import Button from 'react-bootstrap/Button';
import html2canvas from 'html2canvas';

import { ArtBoardSnapshot } from './ArtBoard'

export function SaveDiscardModalBody(props) {
    const closeModal = props.closeModal
    const discardCloseModal = props.discardCloseModal
    const saveCloseModal = props.saveCloseModal

    const name = props.name

    const layers = props.layers
    const images = props.images
    const layersCfg = props.layersCfg

    const captureRef = useRef(null)
    const textRef = useRef(null)

    const [nameLocal, setNameLocal] = useState(name.current)
    const [nameError, setNameError] = useState(false)

    const [localLayersCfg, setLocalLayersCfg ] = useState(null)
    const snapshotWidth = useRef(null)
    const snapshotHeight = useRef(null)
    const snapshotScale = useRef(1.0)

    useEffect(() => {
        /*widgetCapture(366, 246, layers, images, layersCfg).then(pngData => {
            setSnapshot(pngData)
        })*/

        let bb = {x0:1e10,y0:1e10,x1:0,y1:0}

        for( const [key,value] of Object.entries(layersCfg.current) )
        {
            let loc = value.location 

            let x0 = loc.x 
            let y0 = loc.y 
            let x1 = loc.x + loc.width 
            let y1 = loc.y + loc.height

            if( x0 < bb.x0 )
            {
                bb.x0 = x0 
            }

            if( y0 < bb.y0 )
            {
                bb.y0 = y0
            }

            if( x1 >= bb.x1 )
            {
                bb.x1 = x1 
            }
            
            if( y1 >= bb.y1 )
            {
                bb.y1 = y1
            }
        }

        let llcfg = structuredClone(layersCfg.current)
        for( const [key,value] of Object.entries(llcfg) )
        {
            value.location.x -= bb.x0 
            value.location.y -= bb.y0  
        }

        snapshotWidth.current = bb.x1 - bb.x0 
        snapshotHeight.current = bb.y1 - bb.y0

        let sw = 266.0 / snapshotWidth.current 
        let sh = 172.0 / snapshotHeight.current 

        snapshotScale.current = ( sh < sw ) ? sh : sw;

        setLocalLayersCfg({current:llcfg})

        if (textRef.current) {
            textRef.current.focus()
        }
    }, [])

    const save = () => {
        //let pngData = snapshot_div.toDataURL().split(';base64,')[1];

        html2canvas(captureRef.current, {scale: 2}).then( canvas => {
            const pngData = canvas.toDataURL('image/png').split(';base64,')[1];;

            if (pngData == null) {
                return
            }

            if (nameLocal == "") {
                setNameError(true)
                return
            }
            setNameError(false)

            name.current = nameLocal
            saveCloseModal(nameLocal, pngData)
        })
    }

    return (
        <>
            <div className='d-flex justify-content-between' style={{ width: '100%', height: '172px', padding: 0 }}>
                <div className="d-flex justify-content-center"  
                     style={{ width: '266px', height: '172px', overflow:'hidden' }}
                     ref={captureRef}
                >
                    
                    { localLayersCfg &&
                    <div style={{ width: snapshotWidth.current, 
                                  height: snapshotHeight.current, 
                                  transform:`scale(${snapshotScale.current})`,
                                  transformOrigin: "top center"}}>
                        <ArtBoardSnapshot layers={layers} images={images} layersCfg={localLayersCfg}/>
                    </div>
                    }
        {/* <img style={{ border: '0.5px solid #c5c5c5' }} src={"data:image/png;base64, " + snapshot} />*/}
                </div>

                <div style={{ width: '180px', height: '172px', fontSize: '9px' }}>
                    <Form>
                        <span style={{ fontSize: '9px', fontWeight: 200, marginBottom: '10px', display: 'block' }}>
                            Choose a name for your widget.
                        </span>
                        <Form.Group className="mb-2" controlId="exampleForm.ControlInput1">
                            <Form.Label style={{ marginBottom: '2px' }}>Widget Name*</Form.Label>
                            <Form.Control
                                className="custom-input"
                                value={nameLocal}
                                onChange={e => setNameLocal(e.target.value)}
                                style={{ width: '163px', height: '27px' }}
                                isInvalid={nameError}
                                ref={textRef}
                            />
                        </Form.Group>
                        <Form.Group className="mb-3" controlId="exampleForm.ControlInput1">
                            <Form.Label style={{ marginBottom: '2px' }}>Describe</Form.Label>
                            <Form.Control className="custom-input"
                                          style={{ width: '163px', height: '45px' }}
                            />
                        </Form.Group>

                        <Button variant="primary" style={{ width: '50px', height: '25px', marginRight: '5px', textTransform: 'none', fontSize: '11px', padding: '3px' }} onClick={save}>Save</Button>

                        <Button variant="dark" style={{ width: '50px', height: '25px', marginRight: '5px', textTransform: 'none', fontSize: '11px', padding: '3px' }} onClick={closeModal}>Close</Button>
                        <Button variant="dark" style={{ width: '50px', height: '25px', textTransform: 'none', fontSize: '11px', padding: '3px' }} onClick={discardCloseModal}>Discard</Button>

                    </Form>
                    <div>
                    </div>
                </div>
            </div>
        </>
    )
}


export default function SaveDiscardModal(props) {
    const showModal = props.showModal
    const closeModal = props.closeModal
    const discardCloseModal = props.discardCloseModal
    const saveCloseModal = props.saveCloseModal

    const name = props.name
    const setName = props.setName
    const nameError = props.nameError

    const layers = props.layers
    const images = props.images
    const layersCfg = props.layersCfg

    return (
        <Modal show={showModal}
               onHide={closeModal}
               centered
              style={{ display: 'flex', justifyContent: 'center',
                       alignItems: 'center', margin: 'auto',
                }}
        >
            <div style={{ width: '490px', height: '260px',
                          padding: '15px', backgroundColor: 'white',
                          borderRadius: '5px',
                    }}
            >
                <div className="d-flex justify-content-between align-items-center fw-light mb-3"
                     style={{ height: '20px', width: '100%', fontSize: 15 }}
                >
                    <b>Save or Discard</b>
                    <img src="/images/icon/close-square.svg"
                         onClick={closeModal}
                         style={{ cursor: 'pointer' }}
                         alt="Close"
                    />
                </div>

                {showModal && (
                <SaveDiscardModalBody closeModal={closeModal}
                                      discardCloseModal={discardCloseModal}
                                      saveCloseModal={saveCloseModal}
                                      name={name}
                                      setName={setName}
                                      nameError={nameError}
                                      layers={layers}
                                      images={images}
                                      layersCfg={layersCfg}
                />
                )}
            </div>
        </Modal>
    )
}

